import { createSlice } from "@reduxjs/toolkit";

import { AtiraThunk } from "../AtiraThunk";
import { DeleteBillDto } from "../../model/bill/dto/DeleteBillDto";
import { BillAxios } from "../../axios/bill/bill.axios";
import { GetLatestBillsDto } from "../../model/bill/dto/GetLatestBillsDto";
import { UpdateBillDto } from "../../model/bill/dto/UpdateBillDto";
import { PageDto } from "../../model/meta/dto/PageDto";
import { PageResponseDto } from "../../model/meta/dto/PageResponseDto";
import { Bill } from "../../model/bill/types/Bill";
import { CreateBillDto } from "../../model/bill/dto/CreateBillDto";

interface BillReducer {
  latestBills: Bill[];
  latestBillsLoading: boolean;
  latestBillsMeta: PageDto;
  //
  billsTablePageSize: number;
  billsTablePage: number;
  //
  currentBillNumber: number;
}

const initialState = Object.freeze<BillReducer>({
  latestBills: [],
  latestBillsLoading: false,
  latestBillsMeta: {
    page: 0,
    count: 10,
  },
  //
  billsTablePageSize: 10,
  billsTablePage: 1,
  currentBillNumber: 0,
});

const deleteBill = AtiraThunk<void, DeleteBillDto>("/bill/delete", (dto) =>
  BillAxios.deleteBill(dto)
);

const updateBill = AtiraThunk<void, UpdateBillDto>("/entry/update", (dto) =>
  BillAxios.updateBill(dto)
);

const getLatestBills = AtiraThunk<PageResponseDto<Bill[]>, GetLatestBillsDto>(
  `/bill/latest`,
  BillAxios.getLatestBills
);

const getBillNumber = AtiraThunk<{ billNumber: number }, void>(
  "/bill/number",
  BillAxios.getBillNumber
);

const createBill = AtiraThunk<Bill, CreateBillDto>(
  "/bill/create",
  BillAxios.createBill
);

const billSlice = createSlice({
  name: "bill",
  initialState,
  reducers: {
    setBillsTablePageSize: (state, action) => {
      state.billsTablePageSize = action.payload;
    },

    setBillsTablePage: (state, action) => {
      state.billsTablePage = action.payload;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(getLatestBills.pending, (state) => {
      state.latestBillsLoading = true;
    });
    addCase(getLatestBills.fulfilled, (state, action) => {
      state.latestBillsMeta = action.payload.meta;
      state.latestBillsLoading = false;
      state.latestBills = action.payload.data || [];
    });
    addCase(getLatestBills.rejected, (state) => {
      state.latestBillsLoading = false;
    });

    addCase(getBillNumber.fulfilled, (state, action) => {
      state.currentBillNumber = action.payload.billNumber;
    });
  },
});

export const billActions = {
  ...billSlice.actions,
  updateBill,
  deleteBill,
  getLatestBills,
  createBill,
  getBillNumber,
};

export default billSlice.reducer;
